import {useState, useEffect} from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../constants';

export function useGetKjeder() {
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [kjeder, setKjeder] = useState([]);

    useEffect(() => {
        async function getKjeder() {
            setIsLoading(true);
            setIsError(false);

            try {
                const response = await axios.get(`${API_BASE_URL}/kjedes?populate=*`)
                console.log(response);
                setKjeder(response.data.data);
            } catch(error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }

        getKjeder();
    },[])
    return {isLoading, isError, kjeder}
}

export default useGetKjeder;